"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPENSE_TRACKING = void 0;
var EXPENSE_TRACKING = {
  BUTTON__SELECT_ACCOUNT_REP: 'crmExpenseTracking-button-selectAccountRepresentative',
  BUTTON__SELECT_TYPE: 'crmExpenseTracking-button-selectType',
  BUTTON__SELECT_DATE: 'crmExpenseTracking-button-selectDate',
  BUTTON__EXPORT_EXPENSES: 'crmExpenseTracking-button-exportExpenses',
  BUTTON__ADD_EXPENSE: 'crmExpenseTracking-button-addExpense',
  TEXT__ACCOUNT_REP: 'crmExpenseTracking-span-accountRepresentative',
  TEXT__TYPE: 'crmExpenseTracking-span-expenseType',
  TEXT__DATE: 'crmExpenseTracking-span-date',
  TEXT__MONEY_SPENT: 'crmExpenseTracking-span-moneySpent'
};
exports.EXPENSE_TRACKING = EXPENSE_TRACKING;